<template>
  <!-- 支付协议管理列表页 -->
  <div>
    <a-card title="担保人管理" style="margin: 20px">
      <!-- 头部筛选区域 -->
      <div class="selected-box">
        <!-- 渠道名称 -->
        <div class="selected-box-item">
          <span class="left-item">渠道名称</span>
          <a-select v-model="selectedData.channelNo" placeholder="请选择渠道">
            <a-select-option v-for="(item, ind) in JSON.parse(this.$session.getItem('coreCompanyList'))"
              :key="'channelNo' + ind" :value="item.channelNo">{{ item.channelName }}</a-select-option>
          </a-select>
        </div>
        <!-- 机构ID -->
<!--        <div class="selected-box-item">-->
<!--          <span class="left-item">机构</span>-->
<!--          <DepartmentChoose :department-id.sync="selectedData.departmentId"></DepartmentChoose>-->
<!--        </div>-->
        <!-- 担保人账号 -->
        <div class="selected-box-item">
          <span class="left-item">担保人账号</span>
          <a-input v-model.trim="selectedData.accountNoDb" placeholder="请输入担保人账号"></a-input>
        </div>
        <!-- 担保人户名 -->
        <div class="selected-box-item">
          <span class="left-item">担保人户名</span>
          <a-input v-model.trim="selectedData.accountNameDb" placeholder="请输入担保人户名"></a-input>
        </div>

        <div class="selected-box-item" style="display: block">
          <a-button type="primary" @click="handleQuery">查询</a-button>
          <a-button style="margin-left: 20px" @click="handleReset">重置</a-button>
        </div>
      </div>
      <!-- 表格区域 -->
      <div class="table-box">
        <div class="table-box-handle">
          <a-button type="primary" @click="addBtn">

            新增

          </a-button>
          <a-button type="primary" @click="editBtn" v-if="$authority('paymentAgreementModification')" :disabled="selectCustData?.length!==1">修改</a-button>
          <a-button type="primary" @click="viewBtn" v-if="$authority('paymentAgreementView')" :disabled="selectCustData?.length!==1">查看</a-button>
          <a-button type="danger" @click="delBtn" v-if="$authority('paymentAgreementDeletion')" :disabled="selectCustData?.length!==1">删除</a-button>
        </div>
        <div class="table-main">
          <a-table size="small" :scroll="{ x: 600 }" :row-selection="{
            selectedRowKeys: selectedRowKeys,
            onChange: onSelectChange,
          }" :customRow="clickrow" :columns="columns" :data-source="data" :pagination="false"
            :rowKey="(record, index) => `${record.id}`">
          </a-table>
        </div>

        <lcfs-pagination :page-no.sync="pageNo" :page-size.sync="pageSize"
                         :total="total" :fn="getPayProtocolList"></lcfs-pagination>
      </div>
      <!-- 分页部分 -->
<!--      <div class="paginationBox">-->
<!--        <a-button class="Homepage" :disabled="Number(pageNo) == 1" @click="Homepage">-->
<!--          首页-->
<!--        </a-button> <a-pagination v-model.trim="pageNo" :page-size-options="pageSizeOptions" :total="total"-->
<!--          show-size-changer :page-size="pageSize" @change="pagechange" @showSizeChange="onShowSizeChange"-->
<!--          :item-render="itemRender">-->

<!--        </a-pagination>-->
<!--        <a-button @click="Trailingpage" :disabled="pageNo == Math.ceil(Number(total) / Number(pageSize))"-->
<!--          class="Trailingpage">-->
<!--          尾页-->
<!--        </a-button>-->
<!--      </div>-->
      <!-- 删除按钮弹框 -->
      <div class="del-dialog">
        <a-modal title="提示" :body-style="{ textAlign: 'center' }" :visible="isShowDelDialog" :centered="true"
          @ok="handleOk" @cancel="isShowDelDialog = false">
          <p>是否确认删除?</p>
        </a-modal>
      </div>
      <div class="add-dialog">
        <!-- 新增担保人弹框 -->
        <a-modal title="担保人新增" :visible="isVisibleAddDialog" @cancel="isCancel" :centered="true"
          :body-style="{ textAlign: 'center' }" :footer="null">
          <a-form-model ref="addruleForm" :rules="rules" :model="addDbAccountData" :label-col="{ span: 7, offset: 1 }"
            :wrapperCol="{ span: 12 }" labelAlign="left">

            <a-form-model-item label="担保人:" prop="accountNameDb">
              <WalletChooseDialog v-model="addDbAccountData.accountNameDb" :accountClass="'0'"
                @chooseDone="chooseWalletDone"></WalletChooseDialog>
            </a-form-model-item>

            <a-form-model-item label="担保账户:" prop="accountNoDb">
              <a-input v-model="addDbAccountData.accountNoDb" disabled></a-input>
            </a-form-model-item>

            <a-form-model-item label="贷款产品:" prop="productId">
              <a-select :disabled="isView" v-model.trim="addDbAccountData.productId" @change="productIdcahnge"
                placeholder="请选择产品">
                <a-select-option v-for="item in productIdlist" :item="item" :key="item.productId"  :value="item.productId">
                  {{ item.productName }}
                </a-select-option>
              </a-select>
            </a-form-model-item>

            <a-form-model-item label="最大担保金额:" prop="maxAmount">
              <input-balance :disabled="isView" v-model="addDbAccountData.maxAmount"></input-balance>
            </a-form-model-item>
          </a-form-model>
          <div class="container-item">
            <a-row>
              <a-col :span="4"></a-col>
              <a-col :span="18">
                <a-button v-if="!isView" type="primary" @click="onSubmit">保存</a-button>
                <a-button @click="isCancel">取消</a-button>
              </a-col>
            </a-row>
          </div>
        </a-modal>
      </div>
    </a-card>
  </div>
</template>

<script>
import { message } from 'ant-design-vue'
import WalletInfo from '@/view/components/WalletInfo.vue'
import Balance from '@/view/components/Balance.vue'
import WalletChooseDialog from '@/view/components/ChooseDialog/WalletChooseDialog.vue'
import DepartmentChoose from "@/view/components/DepartmentChoose.vue";
import DeptInfo from "@/view/components/DeptInfo.vue";
import ChannelInfo from "@/view/components/ChannelInfo.vue";
import InputBalance from "@/view/components/InputBalance.vue";
import LcfsPagination from "@/view/components/LcfsPagination.vue";

const data = []

export default {
  name: 'GuarantorManage',
  props: {},
  components: {LcfsPagination, DepartmentChoose, DeptInfo, ChannelInfo, WalletInfo, Balance, WalletChooseDialog,InputBalance },
  data() {
    return {
      // 表格数据
      data,
      columns: [
        {
          title: 'No',
          customRender: (text, record, index) =>
            `${Number(this.pageNo - 1) * Number(this.pageSize) +
            Number(index + 1)
            }`,
          align: 'center',
          key: 'sort',
          width: 55
        },
        {
          title: '最大担保金额（单户）',
          dataIndex: 'maxAmount',
          key: 'maxAmount',
          width: 200,
          align: 'right',
          customRender: (text) => {
            return <Balance amount={Number(text)/10000} suffix="万"></Balance>
          }
        },
        {
          title: '担保人',
          dataIndex: 'accountNoDb',
          key: 'accountNoDb',
          ellipsis: true,
          align: 'left',
          customRender: (text, record) => {
            return <WalletInfo accountClass={'0'} accountNo={text} accountName={record.accountNameDb} showAccountNo={false} showAccountName={true}></WalletInfo>
          }
        },
        {
          title: "机构",
          dataIndex: "departmentId",
          align: "center",
          ellipsis: true,
          customRender: (text) => {
            return <DeptInfo dept-id={text}></DeptInfo>
          },
        },
        {
          title: '渠道', dataIndex: 'channelNo', align: 'center', width: 160,
          customRender: (text) => <ChannelInfo channel-no={text}></ChannelInfo>
        },
      ],
      selectedRowKeys: [],
      // 筛选参数
      selectedData: {
        // 机构ID
        departmentId: undefined,
        // 	担保人账号
        accountNoDb: '',
        // 担保人户名
        accountNameDb: '',
        // 	渠道名称
        channelName: '',
      },
      isView: false,
      addDbAccountData: {
        departmentId: '',
        appNo: '',
        channelNo: '',//	渠道编号
        channelName: '',
        productId: undefined,//	产品编号
        //	担保人账号
        accountNoDb: '',
        //	担保人户名
        accountNameDb: '',
        maxAmount: 0,//	最大担保金额
      },
      dbAccountId: '',
      rules: {
        accountNameDb: [{ required: true, message: '请选择担保账户', trigger: 'change' },],
        accountNoDb: [{ required: true, message: '请填写担保账号', trigger: 'blur' },],
        productId: [{ required: true, message: '请选择贷款产品', trigger: 'change' },],
        maxAmount: [{ required: true, message: '请输入最大担保金额', trigger: 'blur' },]
      },
      productIdlist: [],
      // 当前页
      pageNo: 1,
      // 一页显示多少条
      pageSize: 10,
      // 总数
      total: 0,
      //分页大小
      pageSizeOptions: ['10', '20', '30', '40', '50'],
      isShowDelDialog: false,
      selectCustData: [],
      isVisibleAddDialog: false,
      channelNameList: []
    }
  },
  computed: {},
  watch: {},
  created() {
    // 获取机构列表
    this.channelNameList = JSON.parse(this.$session.getItem('coreCompanyList'))
  },
  mounted() {

    // if (sessionStorage.getItem('msgInfo')) {
    //   this.selectedData = this.$store.state.searchMsgInfo
    // }
    // 获取列表
    this.getPayProtocolList()
  },
  deactivated() {
    sessionStorage.removeItem('msgInfo')

  },
  destroyed() {
    sessionStorage.removeItem('msgInfo')
  },
  methods: {
    findItemById(dataObj, idToFind) {
      // 基本情况：如果当前数据对象具有匹配的ID，返回其名称
      if (dataObj == {}) return
      if (dataObj.coreDepartment?.id === idToFind) {
        return dataObj.coreDepartment.name
      }
      // 递归情况：在子数组中搜索
      if (dataObj.children && dataObj.children.length > 0) {
        for (const child of dataObj.children) {
          const foundName = this.findItemById(child, idToFind)
          if (foundName) {
            return foundName
            // 如果在子节点中找到，则返回名称
          }
        }
      }
      // 如果在数据对象中未找到匹配的ID，则返回null
      return null
    },

    // 获取列表函数
    async getPayProtocolList() {
      let data = {}
      this.selectCustData = []
      this.selectedRowKeys = []
      data.pageNo = this.pageNo
      data.pageSize = this.pageSize
      // obj是个对象
      data.obj = JSON.parse(JSON.stringify(this.selectedData))
      let res = await this.api.guarantorListApi(data)
      if (res.code == 200) {
        this.data = res.data.records
        this.pageNo = res.data.current
        this.pageSize = res.data.size
        this.total = res.data.total
      } else {
        this.$message.error(res.info)
      }
    },
    // 查询
    handleQuery() {
      this.pageNo = 1
      this.getPayProtocolList()
    },
    // 重置
    handleReset() {
      this.selectedRowKeys = []
      this.pageNo = 1
      this.pageSize = 10
      this.selectedData = {
        // 机构ID
        departmentId: undefined,
        // 	担保人账号
        accountNoDb: '',
        // 担保人户名
        accountNameDb: '',
        // 	渠道名称
        channelName: '',
      }
      this.getPayProtocolList()
    },
    // 选中行的回调
    onSelectChange(val, row) {
      this.selectedRowKeys = val
      this.selectCustData = row
      //
      // this.selectedRowKeys = val
      // if (selectedRows.length > 1) {
      //   //获取选中的数据的key
      //   var selectNumber = this.selectedRowKeys[1]
      //   //清空选中的key
      //   this.selectedRowKeys = []
      //   //选中的数据的key重新赋值给selectedRowKeys
      //   this.selectedRowKeys.push(selectNumber)
      // }
      // //获取选中的数据详细信息
      // this.selectCustData = selectedRows

    },
    clickrow(record) {
      return {
        on: {
          click: () => {
            let id = record.id.toString()
            let index = this.selectedRowKeys.findIndex((item) => id == item)
            if (index == -1) {
              this.selectedRowKeys.push(id)
              this.selectCustData.push(record)
              // console.log(this.selectCustData, 'this.selectCustData');
            } else {
              this.selectedRowKeys.splice(index, 1)
              this.selectCustData.splice(index, 1)
            }
          }
        }
      }
    },
    addBtn() {
      this.addDbAccountData = {
        departmentId: '',
        appNo: '',
        channelNo: '',//	渠道编号
        channelName: "",
        productId: undefined,//	产品编号
        //	担保人账号
        accountNoDb: '',
        //	担保人户名
        accountNameDb: '',
        maxAmount: 0,//	最大担保金额
      }
      this.selectCustData = []
      this.selectedRowKeys = []
      this.isVisibleAddDialog = true
    },
    // 编辑跳转
    editBtn() {
      if (this.selectCustData.length != 1) {
        return this.$message.warning('请选择一条记录!')
      }

      this.dbAccountId = this.selectCustData[0]?.id
      this.details()
    },
    // 查看跳转
    viewBtn() {
      if (this.selectCustData.length != 1) {
        return this.$message.warning('请选择一条记录!')
      }
      this.isView = true
      // console.log(this.selectCustData);
      // 调用详情接口
      this.dbAccountId = this.selectCustData[0]?.id
      this.details()
    },
    // 删除
    delBtn() {
      if (this.selectCustData.length != 1) {
        return this.$message.warning('请选择一条记录!')
      }
      this.isShowDelDialog = true
      this.dbAccountId = this.selectCustData[0]?.id
    },
    // 弹框确认删除事件
    async handleOk() {

      let res = await this.api.delDbAccountApi(this.dbAccountId)
      if (res.code == 200) {
        this.$message.success(res.info)
        this.selectedRowKeys = []
      } else {
        return this.$message.error(res.info)
      }
      this.getPayProtocolList()
      this.isShowDelDialog = false
    },
    // 选中担保人
    chooseWalletDone(wallet) {
      console.log(wallet);
      this.addDbAccountData.departmentId = wallet.departmentId
      this.addDbAccountData.channelNo = wallet.channelNo
      this.addDbAccountData.appNo = wallet.appNo
      this.addDbAccountData.accountNameDb = wallet.accountName
      this.addDbAccountData.accountNoDb = wallet.accountNo
      this.creditProductInfolist()
    },
    filterChannelName() {
      let channelName = ''
      this.channelNameList.reduce((pre, item) => {
        if (item.channelNo === this.addDbAccountData.channelNo) {
          channelName = item.channelName
        }
      }, '')
      return channelName
    },
    //  获取产品编号列表
    async creditProductInfolist() {
      const res = await this.api.creditProductInfolistApi({
        channelNo: this.addDbAccountData.channelNo
      });
      if (res.code !== 200) {
        this.$message.warning(res.info);
        return;
      }
      this.productIdlist = res.data;
    },

    // 产品编号发生变化
    productIdcahnge(value, option) {
      this.addDbAccountData.productId = option.data.attrs.item.productId
    },
    // 校验
    onSubmit() {
      this.$refs.addruleForm.validate((valid) => {
        if (valid) {
          // 校验成功调用保存接口
          this.addDbAccount()
        } else {
          console.log("error submit!!");
        }

        this.addDbAccountData = {
          channelNo: '',//	渠道编号
          channelName: '',//渠道名称
          productId: undefined,//	产品编号
          //	担保人账号
          accountNoDb: '',
          //	担保人户名
          accountNameDb: '',
          maxAmount: 0,//	最大担保金额
        }
      });
    },
    isCancel() {
      this.isVisibleAddDialog = false
      this.isView = false
    },
    // 新增或者编辑担保人保存
    async addDbAccount() {
      this.addDbAccountData.maxAmount = Number(this.addDbAccountData.maxAmount)
      this.addDbAccountData.channelName = this.filterChannelName()
      let res = await this.api.addDbAccountApi(this.addDbAccountData)
      if (res.code == 200) {
        this.$message.success(res.info)
        this.selectCustData = []
        this.selectedRowKeys = []
        // 获取表格
        this.getPayProtocolList()
      } else {
        this.$message.error(res.info)
      }
      // 关闭弹框
      this.isVisibleAddDialog = false;
    },
    // 详情
    async details() {
      let res = await this.api.detailsDbAccountApi(this.dbAccountId)
      if (res.code == 200) {
        this.addDbAccountData = res.data
        // 获取产品
        this.creditProductInfolist()
        // 打开弹框
        this.isVisibleAddDialog = true
      } else {
        this.$message.error(res.info)
      }
    }
  },
}
</script>

<style lang="less" scoped>
.selected-box {
  display: flex;
  flex-wrap: wrap;

  /deep/ .selected-box-item {
    margin-right: 20px;
    display: flex;
    justify-content: space-between;
    // width: 280px;
    margin-bottom: 20px;
    align-items: center;

    .left-item {
      margin-right: 15px;
    }

    .ant-input {
      width: 200px;
    }

    .ant-select-selection--single {
      width: 200px;
    }
  }
}

.table-box {
  .table-box-handle {
    margin-bottom: 20px;
  }
}
</style>
